import * as React from "react";
import FormContext, { initFormStore } from "@/contexts/Form";
import Article from "@/components/molecules/Article";
import Title from "@/components/atoms/Title";
import PropertyType from "@/constants/PropertyType";
import form from "@/utils/form";
import CapsuleNextButton from "@/components/molecules/CapsuleNextButton";
import contract, { HIDDEN_COMPONENT_OPTIONS, isHiddenComponent, Feature } from "@/utils/contract";
import ContractContext, { initContractStore } from "@/contexts/Contract";
import styled from "@emotion/styled";
import { useTheme } from "@/hooks/useTheme";
import Mansion from "./mansion";
import Land from "./land";
import House from "./house";

const StyledDesc = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

type PropertyDetailBlockProps = {
  onNext: () => void;
};

const PropertyDetailBlockNew = ({ onNext }: PropertyDetailBlockProps) => {
  const { COLOR_THEME } = useTheme();
  const {
    state: { values },
    isValidProperty,
    isValidPropertyDetails,
    isRequiredPropertyDetails,
  } = React.useContext(FormContext) || initFormStore(form);

  const {
    state: { featuresObj },
  } = React.useContext(ContractContext) || initContractStore(contract);
  const isTrafficInfoAutoLinked = featuresObj[Feature.TRAFFIC_INFO_AUTO_LINK]?.enabled;
  const isConnectingRoadInfoAutoEnabled = featuresObj[Feature.CONNECTING_ROAD_INFO_AUTO]?.enabled;

  const firstRef = React.useRef(true);
  const [showNextButton, setShowNextButton] = React.useState(true);

  const handleNext = () => {
    firstRef.current = false;
    onNext();
  };

  const isValid =
    isValidProperty(isTrafficInfoAutoLinked) &&
    isValidPropertyDetails(isConnectingRoadInfoAutoEnabled) &&
    isRequiredPropertyDetails(isConnectingRoadInfoAutoEnabled);

  const hiddenPurchaseIntentionComponent = isHiddenComponent(featuresObj, HIDDEN_COMPONENT_OPTIONS.PURCHASE_INTENTION);

  const renderPropertyBlockByType = () => {
    switch (values.propertyType) {
      case PropertyType.MANSION:
        return <Mansion />;
      case PropertyType.LAND:
        return <Land />;
      case PropertyType.HOUSE:
        return <House />;
      default:
        return false;
    }
  };

  return (
    <Article>
      <StyledDesc>
        <Title color={COLOR_THEME.extras?.secondary}>詳細情報をご入力ください</Title>
      </StyledDesc>
      {renderPropertyBlockByType()}
      {showNextButton && (
        <CapsuleNextButton
          disabled={firstRef.current && !isValid}
          value={hiddenPurchaseIntentionComponent ? "もう少しで完了です" : "次へ"}
          className={hiddenPurchaseIntentionComponent ? "formBtn w250" : "formBtn"}
          onClick={() => {
            setShowNextButton(false);
            handleNext();
          }}
        />
      )}
    </Article>
  );
};

export default PropertyDetailBlockNew;
